import { Phone, Mail } from "lucide-react";
import { TEAM } from "../../lib/constants";

export default function Team() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="relative bg-[#F8F9FA] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="mb-14 max-w-3xl">
          <p className="nps-eyebrow nps-divider-gold mb-5">Our Team</p>
          <h2 className="font-display font-bold text-[#0B1D3A] text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight">
            The people behind
            <br />
            <span className="text-[#C9A961]">Noble Power Solutions.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {TEAM.map((member) => (
            <article
              key={member.id}
              data-testid={`team-card-${member.id}`}
              className="group bg-white border border-[#E5E7EB] rounded-sm overflow-hidden hover:border-[#1E3A5F] hover:shadow-lg transition-all duration-300"
            >
              <div className="grid grid-cols-5">
                {/* Photo */}
                <div className="col-span-2 relative bg-[#0B1D3A] overflow-hidden">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-full h-full object-cover aspect-[3/4] transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                {/* Info */}
                <div className="col-span-3 p-6 lg:p-8 flex flex-col justify-center">
                  <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#C9A961] mb-3">
                    {member.title}
                  </p>
                  <h3 className="font-display font-bold text-[#0B1D3A] text-2xl lg:text-3xl tracking-tight leading-tight">
                    {member.name}
                  </h3>

                  <div className="mt-7 pt-6 border-t border-[#E5E7EB] space-y-4">
                    <a
                      href={member.phoneHref}
                      data-testid={`team-${member.id}-phone`}
                      className="flex items-center gap-3 group/link"
                    >
                      <span className="w-9 h-9 bg-[#0B1D3A] flex items-center justify-center rounded-sm flex-shrink-0 group-hover/link:bg-[#C9A961] transition-colors">
                        <Phone className="w-4 h-4 text-[#C9A961] group-hover/link:text-[#0B1D3A] transition-colors" />
                      </span>
                      <div>
                        <p className="text-[10px] uppercase tracking-[0.22em] text-[#4B5563] font-semibold">
                          Direct Line
                        </p>
                        <p className="font-display font-semibold text-[#0B1D3A] text-base group-hover/link:text-[#C9A961] transition-colors">
                          {member.phone}
                        </p>
                      </div>
                    </a>

                    <a
                      href={member.emailHref}
                      data-testid={`team-${member.id}-email`}
                      className="flex items-center gap-3 group/link"
                    >
                      <span className="w-9 h-9 bg-[#0B1D3A] flex items-center justify-center rounded-sm flex-shrink-0 group-hover/link:bg-[#C9A961] transition-colors">
                        <Mail className="w-4 h-4 text-[#C9A961] group-hover/link:text-[#0B1D3A] transition-colors" />
                      </span>
                      <div className="min-w-0">
                        <p className="text-[10px] uppercase tracking-[0.22em] text-[#4B5563] font-semibold">
                          Email
                        </p>
                        <p className="font-display font-semibold text-[#0B1D3A] text-[15px] group-hover/link:text-[#C9A961] transition-colors break-all">
                          {member.email}
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
